import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import HomeDocumentSectionItem from './home-document-section-item';
import HomeDocumentSectionSharingFile from './home-document-section-sharing-file';
import { generatePdfThumbnail } from 'helper/generate-pdf-thumbnail';
import * as CommonActionType from '../../../Common/constants';
import * as ProjectActionType from '../../constants';
import * as LotActionType from 'Lots/constants';
import folder from 'assets/img/folder.png';

const MAXIMUM_VIDEO_SIZE = 1024 * 1024 * 500;

class HomeDocumentSection extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    documentTypeId: PropTypes.string,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    ProjectDocument: PropTypes.object,
    lot: PropTypes.object,
    HomeownerDocuments: PropTypes.array,
    hidden: PropTypes.bool,
    manualType: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.AWSCredential = null;
    this.state = {
      files: [],
      cancelUploadList: {},
      deleteUploadList: {},
      openModalSharingFileWithLot: false
    };
  }

  componentDidMount() {
    console.log('documents mount');
    if (!this.props.hidden) {
      this.fetchDocument();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.hidden && nextProps.hidden !== this.props.hidden) {
      this.onLoadDocument();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot && prevProps.lot.value !== this.props.lot.value) {
      this.fetchDocument();
    }
  }

  onLoadDocument = () => {
    this.setState(
      {
        loadingDocument: true
      },
      this.fetchDocument
    );
  };

  fetchDocument = () => {
    const { projectId, documentTypeId, lot } = this.props;

    if (projectId) {
      this.props.dispatch({
        type: ProjectActionType.GET_PROJECT_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
        params: {
          projectId,
          projectDocumentTypeId: documentTypeId
        },
        callback: () => {
          this.setState({ loadingDocument: false });
        }
      });
    }

    if (lot) {
      const { builderProfile } = lot.extensionValue;

      this.props.dispatch({
        type: LotActionType.GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC,
        params: {
          endpoint: builderProfile.lotSharedDocumentsEndpoint.replace(
            '_projectDocumentTypeId',
            documentTypeId
          ),
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          }
        },
        callback: () => {
          this.setState({ loadingDocument: false });
        }
      });
    }
  };

  onDrop = (accepted, rejected) => {
    const { manualType } = this.props;

    if (rejected.length) {
      const errorMsg =
        manualType === 0
          ? 'Only PDF, PNG, JPG, JPEG supported.'
          : 'Only MP4, MOV, WEBM supported.';
      this.setState({
        error: errorMsg
      });
    } else {
      const acceptLength = manualType === 0 ? 3 : 1;
      if (accepted.length <= acceptLength) {
        if (manualType === 1 && accepted[0].size > MAXIMUM_VIDEO_SIZE) {
          this.setState({
            error: `File size must not exceed ${MAXIMUM_VIDEO_SIZE /
              (1024 * 1024)}MB.`
          });
        } else {
          const currentFileState = [...this.state.files];

          this.setState(
            {
              files: currentFileState.concat(accepted),
              error: null
            },
            () => this.handleFileUpload(accepted)
          );
        }
      } else {
        this.setState({
          error: `Maximum ${acceptLength} file${
            acceptLength === 1 ? '' : 's'
          } allowed at once.`
        });
      }
    }
  };

  handleFileUpload = files => {
    const { projectId } = this.props;

    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `projects/${projectId}`
      },
      callback: awsCredential => {
        this.awsCredential = awsCredential;

        files.map(file => {
          file.uploadId = uuidv4();

          if (file.type === 'application/pdf') {
            //handle get pdf thumbnail
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: (status, callbackData) => {
                if (status === 'pending') {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList
                  });
                } else if (status === 'delete') {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList
                  });
                } else if (status === true) {
                  callbackData.name = file.name;

                  const data = file.preview;

                  generatePdfThumbnail(
                    data,
                    this.handlePdfThumbnail,
                    callbackData
                  );
                }
              }
            });
          } else {
            //handle image file
            this.props.dispatch({
              type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
              paramsUpload: {
                projectId,
                file,
                config: awsCredential
              },
              callback: (status, callbackData) => {
                callbackData.name = file.name;

                if (status === 'pending') {
                  const { cancelUploadList } = this.state;
                  cancelUploadList[callbackData.uploadId] =
                    callbackData.cancelUpload;
                  this.setState({
                    cancelUploadList
                  });
                } else if (status === 'delete') {
                  const { deleteUploadList } = this.state;
                  deleteUploadList[callbackData.uploadId] =
                    callbackData.deleteFile;
                  this.setState({
                    deleteUploadList
                  });
                } else if (status === true) {
                  this.uploadDocumentToServer(callbackData, callbackData);
                }
              }
            });
          }
        });
      }
    });
  };

  handlePdfThumbnail = (thumbnail, fileDataS3) => {
    const { projectId } = this.props;

    thumbnail.name = uuidv4();

    this.props.dispatch({
      type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
      paramsUpload: {
        projectId,
        file: thumbnail,
        config: {
          ...this.awsCredential,
          path: `${this.awsCredential.path}/thumbnail`
        }
      },
      callback: (status, callbackData) => {
        if (status === true) {
          this.uploadDocumentToServer(fileDataS3, callbackData);
        }
      }
    });
  };

  uploadDocumentToServer = (fileData, thumbnailData) => {
    const { projectId, documentTypeId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.UPLOAD_PROJECT_DOCUMENT_TO_SERVER_ASYNC,
      params: {
        projectId,
        projectDocumentTypeId: documentTypeId,
        data: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location,
          thumbnailKey: thumbnailData.data.Key,
          thumbnailUrl: thumbnailData.data.Location
        }
      },
      callback: (status, res) => {
        if (status) {
          this.setState({
            files: this.state.files.filter(
              element => element.name !== res.fileName
            )
          });
        }
      }
    });
  };

  onRemoveDocument = projectDocumentId => {
    const { projectId, documentTypeId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.REMOVE_PROJECT_DOCUMENT_ASYNC,
      params: {
        projectId,
        projectDocumentId,
        projectDocumentTypeId: documentTypeId
      }
    });
  };

  onCancelUpload = fileData => {
    const item = fileData.file;

    const { cancelUploadList } = this.state;
    if (
      !isEmpty(cancelUploadList) &&
      Object.keys(cancelUploadList).includes(item.uploadId)
    ) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          element => element.uploadId !== item.uploadId
        ),
        cancelUploadList
      });
    }
    const { deleteUploadList } = this.state;
    if (
      !isEmpty(deleteUploadList) &&
      Object.keys(deleteUploadList).includes(item.uploadId)
    ) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          element => element.uploadId !== item.uploadId
        ),
        deleteUploadList
      });
    }
  };

  onUpdateFileName = (projectDocumentId, data, callback) => {
    const { projectId, documentTypeId } = this.props;

    this.props.dispatch({
      type: ProjectActionType.UPDATE_PROJECT_DOCUMENT_NAME_ASYNC,
      params: {
        projectId,
        projectDocumentId,
        projectDocumentTypeId: documentTypeId,
        data
      },
      callback
    });
  };

  renderFileUploading = files => {
    const { user, projectId, manualType } = this.props;

    if (files.length) {
      return files.map((file, index) => {
        const data = {
          file,
          fileName: file.name,
          createdBy: user.fullName,
          numberOfSharedLots: 0
        };
        return (
          <HomeDocumentSectionItem
            manualType={manualType}
            mode={projectId ? 'project' : 'lot'}
            loading
            key={index}
            data={data}
            onCancelUpload={this.onCancelUpload}
          />
        );
      });
    }

    return null;
  };

  renderProjectDocument = documents => {
    const { projectId, manualType } = this.props;

    if (documents.length) {
      return orderBy(documents, 'fileName', 'asc').map(item => {
        return (
          <HomeDocumentSectionItem
            manualType={manualType}
            mode={projectId ? 'project' : 'lot'}
            key={item.id}
            data={item}
            onRemoveDocument={this.onRemoveDocument}
            onUpdateFileName={this.onUpdateFileName}
            onClickShareWithLot={this.onClickShareWithLot}
          />
        );
      });
    }

    if (!projectId) {
      return (
        <div className='manuals-documents-no-file'>
          <img
            className='manuals-documents-no-file-ic'
            src={folder}
            alt='no-files'
          />
          <p>No files</p>
        </div>
      );
    }

    return null;
  };

  onClickShareWithLot = data => {
    this.setState({
      openModalSharingFileWithLot: true,
      selectedProjectDocument: data
    });
  };

  onCloseModalSharingFileWithLot = () => {
    this.setState({
      openModalSharingFileWithLot: false
    });
  };

  onClearError = () => {
    this.setState({ error: null });
  };

  renderError = () => {
    const { error } = this.state;

    if (error) {
      setTimeout(this.onClearError, 5000);
      return (
        <div
          className='alert alert-danger'
          style={{ width: '100%', margin: '0 15px 15px' }}
        >
          <p style={{ fontSize: 14 }}>{error}</p>
          <i
            className='fa fa-close'
            style={{
              position: 'absolute',
              top: 14,
              right: 14,
              cursor: 'pointer'
            }}
            onClick={this.onClearError}
          />
        </div>
      );
    }

    return null;
  };

  render() {
    const {
      files,
      openModalSharingFileWithLot,
      selectedProjectDocument,
      loadingDocument
    } = this.state;

    const {
      projectId,
      documentTypeId,
      ProjectDocument,
      HomeownerDocuments,
      manualType
    } = this.props;

    let documents = [];

    if (projectId) {
      if (!isEmpty(ProjectDocument[documentTypeId])) {
        documents = ProjectDocument[documentTypeId];
      }
    } else {
      documents = HomeownerDocuments;
    }

    const documentFileTypeAccept = 'application/pdf, image/jpeg, image/png';

    const videoFileTypeAccept =
      'video/quicktime, video/x-quicktime, video/mp4, video/webm, audio/webm';

    const acceptFileType =
      manualType === 0 ? documentFileTypeAccept : videoFileTypeAccept;

    if (!projectId && loadingDocument) {
      return null;
    }

    return (
      <div className='project-document-section-wrapper'>
        {this.renderError()}

        {this.renderProjectDocument(documents)}

        {this.renderFileUploading(files)}

        {projectId && (
          <Dropzone
            disableClick
            accept={acceptFileType}
            ref={node => {
              this.dropzoneRef = node;
            }}
            onDrop={this.onDrop.bind(this)}
            className='project-document-dropzone col-sm-4 col-md-4 col-lg-3'
          >
            <div className='upload-block'>
              <span className='files-upload-ic'>
                <i className='fa fa-cloud-upload' />
              </span>
              Drag files here or{' '}
              <span
                className='files-browse-txt'
                onClick={() => {
                  this.dropzoneRef.open();
                }}
              >
                browse.
              </span>
            </div>
          </Dropzone>
        )}

        {openModalSharingFileWithLot && (
          <HomeDocumentSectionSharingFile
            show={openModalSharingFileWithLot}
            onCloseModal={this.onCloseModalSharingFileWithLot}
            projectId={projectId}
            projectDocumentTypeId={documentTypeId}
            projectDocumentId={selectedProjectDocument.id}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ProjectDocument: state.ProjectStore.ProjectDocument,
    user: state.UserStore.UserProfile,
    HomeownerDocuments: state.LotStore.HomeownerDocuments
  };
};

export default connect(mapStateToProps)(HomeDocumentSection);



// WEBPACK FOOTER //
// ./src/Projects/Components/Document/home-document-section.js